import { ProductManufacturingProcess } from '@/src/packages/components/pages/Product/ProductManufacturingProcess';
import { useRangeContext } from '@/src/packages/components/pages/Range/RangeContext';
import { Box } from '@/src/packages/components/ui/Box';
import { Carousel } from '@/src/packages/components/ui/Carousel';
import { Heading } from '@/src/packages/components/ui/Heading';
import { PageSection } from '@/src/packages/components/ui/PageSection';
import { PageSectionSubheading } from '@/src/packages/components/ui/PageSection/PageSectionSubheading';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import Image from 'next/image';
import { SwiperSlide } from 'swiper/react';

export const RangeManufacturingProcesses = () => {
  const {
    range: {
      fields: { manufacturingProcesses },
    },
  } = useRangeContext();

  if (!manufacturingProcesses) return <></>;

  const manufacturingProcess = manufacturingProcesses[0];

  return (
    <ProductManufacturingProcess manufacturingProcess={manufacturingProcess} />
  );
};
